import MouseTrap from 'mousetrap';
import React, { Suspense, useEffect, useState } from 'react';

import { useUser } from '../../context/PortalContext/PortalContext';
import { IUserObj } from '../../context/PortalContext/userObj';

const Palette = React.lazy(() => import('./Palette'));

function Commander() {
  const usr = useUser() as IUserObj;
  const [show, setShow] = useState(false);

  useEffect(() => {
    MouseTrap.bind(['command+k', 'ctrl+k'], (e) => {
      if (e?.preventDefault) {
        e.preventDefault();
      }
      setShow((show) => !show);
    });

    MouseTrap.prototype.stopCallback = (e, element, combo) => {
      // if the element has the class "mousetrap" then no need to stop
      if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
        return false;
      }

      // if it's command+k or ctrl+k then don't stop
      if (combo === 'command+k' || combo === 'ctrl+k') {
        return false;
      }

      // stop for input, select, and textarea
      return element.tagName === 'INPUT' || element.tagName === 'SELECT' || element.tagName === 'TEXTAREA';
    };
  }, []);

  // debounce the show state to prevent the palette from flashing

  if (usr && show) {
    return (
      <Suspense>
        <Palette user={usr} onHide={() => setShow(false)} />
      </Suspense>
    );
  }

  return <></>;
}

export default Commander;
